import { Outlet, createFileRoute } from '@tanstack/react-router';

import { IntegrationDetailsPage } from '../features/demand/integrations/components/IntegrationDetailsPage/IntegrationDetailsPage';

export const Route = createFileRoute(
  '/demand/integrations/$integrationId/demand/$demandPartnerId/details',
)({
  component: IntegrationDetailsRoute,
});

function IntegrationDetailsRoute() {
  const { demandPartnerId, integrationId } = Route.useParams();
  return (
    <IntegrationDetailsPage demandPartnerId={demandPartnerId} integrationId={integrationId}>
      <Outlet />
    </IntegrationDetailsPage>
  );
}
